import { ApplicationState } from 'app/types-store';

export const selectFetchingBreadcrumbs = (state: ApplicationState) =>
  state.linkCodes?.fetchingBreadcrumbs;

export const selectBreadcrumbsOptions = (state: ApplicationState) =>
  state.linkCodes?.breadcrumbsOptions;

export const selectNodeCodetable = (state: ApplicationState) =>
  state.linkCodes?.nodeCodetable;

export const selectFetchingMetadata = (state: ApplicationState) =>
  state.linkCodes?.fetchingMetadata;

export const selectCodetableMetadata = (state: ApplicationState) =>
  state.linkCodes?.codetableMetadata;

export const selectFetchingCodetableAccess = (state: ApplicationState) =>
  state.linkCodes?.fetchingCodetableAccess;

export const selectCodetableAccess = (state: ApplicationState) =>
  state.linkCodes?.codetableAccess;

export const selectRequestedModel = (state: ApplicationState) =>
  state.linkCodes?.requestedModel;

export const selectListBranch = (state: ApplicationState) =>
  state.linkCodes?.listBranch;

export const selectListBranchState = (state: ApplicationState) =>
  state.linkCodes?.listBranchState;

export const selectListActions = (state: ApplicationState) =>
  state.linkCodes?.listActions;

export const selectUpdating = (state: ApplicationState) =>
  state.linkCodes?.updating;

export const selectActionErrors = (state: ApplicationState) =>
  state.linkCodes?.actionErrors;

export const selectActiveValueError = (state: ApplicationState) =>
  state.linkCodes?.activeValueError;

export const selectCodetableValue = (state: ApplicationState) =>
  state.linkCodes?.codetable;

export const selectCategoryValue = (state: ApplicationState) =>
  state.linkCodes?.category;

export const selectActiveValue = (state: ApplicationState) =>
  state.linkCodes?.activeValue;

export const selectActiveType = (state: ApplicationState) =>
  state.linkCodes?.activeType;

export const selectIncludeInactive = (state: ApplicationState) =>
  state.linkCodes?.includeInactive;

export const selectVisibility = (state: ApplicationState) =>
  state.linkCodes?.visiblity;

export const selectLastSelectedRow = (state: ApplicationState) =>
  state.linkCodes?.lastSelectedRow;

export const selectSelectedRows = (state: ApplicationState) =>
  state.linkCodes?.selectedRows;
